import { FC, ReactNode } from 'react';
import { Label } from './styles';
import { Typography } from '../typography';

interface LabelProps {
	children: ReactNode;
	htmlFor?: string;
}

export const LabelText: FC<LabelProps> = ({ children, htmlFor = '' }) => {
	return (
		<Label htmlFor={htmlFor}>
			<Typography mode={'small'}>{children}</Typography>
		</Label>
	);
};
